module.exports = __webpack_public_path__ + "img/NW14.4d0d28f7.jpg";